export var NodeEnv = {
    development: 'development',
    production: 'production',
};
export var DOMAIN = {
    beta: 'test',
    gamma: 'test',
    prod: 'prod',
};
export var REALM = {
    'eu-west-1': 'EUAmazon',
    'us-east-1': 'USAmazon',
    'us-west-2': 'FEAmazon',
};
export var SITE = {
    beta: 'AACChrome.Beta',
    gamma: 'AACChrome.Gamma',
    prod: 'AACChrome.Prod',
};
